import {

  Component,
} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {MessageService} from "primeng/api";
import {DateFormatLangPipe} from "@app/utils/pipes/date-format-lang-pipe";
import {MsfSelectPaginated} from "@components/select/paginated/select-paginated";
import {FormsModule} from "@angular/forms";
import {MsfInput} from "@components/ui/forms/input/input";

import { ButtonDirective} from "primeng/button";
import {SaveButton} from "@components/button/save-button/save-button/save-button";
import {SecondaryButton} from "@components/button/secondary-button/secondary-button";
import {Divider} from "primeng/divider";
import {DatePipe, NgIf} from "@angular/common";
import {CheckboxComponent} from "@components/checkbox";
import {TextareaComponent} from "@components/textarea";
import {GetByIdPipe} from "@app/utils/pipes/get-by-id-pipe";
import {DatePickerComponent} from "@components/date-picker";
import {DialogComponent} from "@components/dialog";


import {RequestMapComponent} from "@components/request-map/request-map.component2";
import {
  DetectedFieldsMapLayerDirective
} from "@app/pages/crop-monitoring/components/request-add-page/detected-fields-map-layer.directive";
import {GroundSurvey} from "@app/pages/crop-monitoring/components/request-add-page/forms/ground-surver/ground-survey";
import {CustomMessageService} from '@app/interceptors/custom-message';


@Component({
  selector: 'app-uav',
  standalone: true,
  templateUrl: './uav.html',
  styleUrl: './uav.scss',
  providers: [
    TranslatePipe,
    DateFormatLangPipe,
    {
      provide: MessageService,
      useClass: CustomMessageService
    },
    DatePipe
  ],
  imports: [
    TranslatePipe,
    DateFormatLangPipe,
    MsfSelectPaginated,
    FormsModule,
    MsfInput,
    ButtonDirective,
    SaveButton,
    SecondaryButton,
    Divider, NgIf,
    CheckboxComponent,
    TextareaComponent, GetByIdPipe,
    DatePickerComponent,
    DialogComponent,
    RequestMapComponent,
    DetectedFieldsMapLayerDirective
  ]
})
export class Uav extends GroundSurvey {

  /** UAV keeps free point placement. The sowing-contour tool is ground survey only. */
  protected override usesSowingSurveyPoint(): boolean {
    return false;
  }

  override loadFieldByPoints(dialogMode = true, lat = this.formData.lat, lng = this.formData.lng) {

  }
}
